module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-4-Inactive-ClubPilates-5ad90060137402e0897fb6904bdee2ab.png";